import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";

const DatasourceFileVine = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 

    useEffect(() => {
        if (!props.IntegrationSettings.DatasourceSettings.Country)
        {
            props.IntegrationSettings.DatasourceSettings.Country = "United States"
        }

        SetReady()
      }, []); 
      
    const UpdateDatasourceSetting = (aValue, aIdentifier) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aValue

        SetReady()
    }

    const SetReady = () => 
    {
        const Ready = (props.IntegrationSettings.DatasourceSettings.ApiKey)
            && (props.IntegrationSettings.DatasourceSettings.ApiSecret)
            && (props.IntegrationSettings.DatasourceSettings.Token)
            && (props.IntegrationSettings.DatasourceSettings.Country)
            && (props.IntegrationSettings.DatasourceSettings.Domain)

        props.OnSetReady(Ready)
    }
    return (
        <div className="scriptitembody">
            
            <div className="wizardfieldname">{Translate("API key").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.ApiKey || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "ApiKey")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("API secret").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="password" value={props.IntegrationSettings.DatasourceSettings.ApiSecret || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "ApiSecret")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("Token").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="password" value={props.IntegrationSettings.DatasourceSettings.Token || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Token")} className="wizardinputfield"/></div>
            
            <div className="wizardfieldname">{Translate("Country").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue">
                <select name="Region" value={props.IntegrationSettings.DatasourceSettings.Country} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Country")} className="wizardinputfield">
                    <option value="United States">United States</option>
                    <option value="Canada">Canada</option>
                </select>
            </div>
            
            <div className="wizardfieldname">{Translate("Domain").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.Domain || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Domain")} className="wizardinputfield"/></div>
                        
        </div>
    );
}

DatasourceFileVine.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceFileVine